import styled from 'styled-components';
import { Page } from 'components/shared/Layout';

export const StyledPage = styled(Page)`
  padding: 8px 8px 50px 8px;
`;

export const InfoContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
`;

export const ActionContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  > button {
    margin-right: 4px;
  }
`;
